module.exports = __webpack_public_path__ + "img/kf.2fcb8bd6.jpg";